var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
import useThunkReducer from 'react-hook-thunk-reducer';
import { DateTime } from 'luxon';
import { ShiftIntervalCategory } from '@amzn/atoz-shiftapp-types';
import { METRIC_NAME, logger } from '@amzn/atoz-shiftapp-metrics';
export var UseShiftActionType;
(function (UseShiftActionType) {
    UseShiftActionType["UpdateScheduleShiftsForDay"] = "UPDATE_SCHEDULE_SHIFTS_FOR_DAY";
    UseShiftActionType["SetScheduleShifts"] = "SET_SCHEDULE_SHIFTS";
})(UseShiftActionType || (UseShiftActionType = {}));
export var actionCreators = {
    updateScheduleShiftsForDay: function (newDate) {
        return function (dispatch, getState) {
            var allScheduleShifts = getState().allScheduleShifts;
            if (allScheduleShifts) {
                var newShiftsForDay = allScheduleShifts.filter(function (scheduleShift) {
                    return DateTime.fromISO(scheduleShift.shift.timeRange.start).toISODate() === newDate.toISODate();
                });
                dispatch({
                    type: UseShiftActionType.UpdateScheduleShiftsForDay,
                    payload: {
                        shiftsForDay: newShiftsForDay,
                        selectedDate: newDate
                    }
                });
            }
        };
    },
    setScheduleShifts: function (scheduleShifts) {
        return function (dispatch) {
            dispatch({
                type: UseShiftActionType.SetScheduleShifts,
                payload: {
                    allScheduleShifts: scheduleShifts
                }
            });
        };
    }
};
export var reducer = function (state, _a) {
    var type = _a.type, payload = _a.payload;
    var result = {};
    switch (type) {
        case UseShiftActionType.UpdateScheduleShiftsForDay:
            result = __assign(__assign({}, state), payload);
            break;
        case UseShiftActionType.SetScheduleShifts:
            result = __assign(__assign({}, state), payload);
            break;
        default:
            throw new Error("No reducer defined for type ".concat(type, " in useShiftState"));
    }
    return result;
};
export var logShiftIntervalDataError = function (scheduleShifts) {
    var logError = function (shiftInterval) {
        var timeRange = shiftInterval.timeRange, category = shiftInterval.category;
        var startTime = DateTime.fromISO(timeRange.start);
        var endTime = DateTime.fromISO(timeRange.end);
        var errorMsg = '';
        if (!startTime.isValid) {
            errorMsg += "start time is not valid time, reason: ".concat(startTime.invalidExplanation, ";");
        }
        if (!endTime.isValid) {
            errorMsg += "end time is not valid time, reason: ".concat(startTime.invalidExplanation, ";");
        }
        if (endTime <= startTime) {
            errorMsg += "end time is before or equal to start time;";
        }
        if (!Object.values(ShiftIntervalCategory).includes(category)) {
            errorMsg += "category ".concat(category, " is unknown");
        }
        if (errorMsg.length > 0) {
            logger.emitCountMetric({
                metricName: METRIC_NAME.DATA_ERROR_INVALID_SHIFT_INTERVAL,
                dimensions: {}
            });
            logger.error("Invalid shift interval data error: ".concat(errorMsg), {
                timeRange: "".concat(timeRange.start, " - ").concat(timeRange.end),
                category: category
            });
        }
    };
    scheduleShifts.forEach(function (shifts) {
        if (shifts.shiftIntervals) {
            shifts.shiftIntervals.forEach(function (shiftInterval) {
                logError(shiftInterval);
            });
        }
    });
};
export var useShiftState = function (_a) {
    var scheduleShifts = _a.scheduleShifts, selectedDate = _a.selectedDate;
    var initialState = {
        shiftsForDay: [],
        selectedDate: selectedDate,
        allScheduleShifts: scheduleShifts
    };
    var _b = useThunkReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    var actions = {
        updateScheduleShiftsForDay: function (date) {
            return dispatch(actionCreators.updateScheduleShiftsForDay(date));
        },
        setScheduleShifts: function (scheduleShifts) {
            return dispatch(actionCreators.setScheduleShifts(scheduleShifts));
        }
    };
    // Update list of shifts if it changes
    useEffect(function () {
        if (scheduleShifts) {
            logShiftIntervalDataError(scheduleShifts);
            actions.setScheduleShifts(scheduleShifts);
            actions.updateScheduleShiftsForDay(selectedDate);
        }
    }, [scheduleShifts]);
    return {
        state: state,
        actions: actions
    };
};
